import React from "react";
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom'
import DefaultDeck from './DefaultDeck';
import NotFound from './slides/NotFound';

export default class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={DefaultDeck} />
          <Route component={DefaultDeck} />
        </Switch>
      </BrowserRouter>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App.js